import { render, staticRenderFns } from "./ClassContentHeader.vue?vue&type=template&id=35715075&"
import script from "./ClassContentHeader.vue?vue&type=script&lang=js&"
export * from "./ClassContentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports